import { styled } from 'config/stitches.config'

export const StyledFormList = styled('div', {})
